import { render, staticRenderFns } from "./BaseLandingPage.vue?vue&type=template&id=af1569e6&scoped=true"
import script from "./BaseLandingPage.vue?vue&type=script&lang=js"
export * from "./BaseLandingPage.vue?vue&type=script&lang=js"
import style0 from "./BaseLandingPage.vue?vue&type=style&index=0&id=af1569e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1569e6",
  null
  
)

export default component.exports